module.exports = __webpack_public_path__ + "img/aeroland-pricing-05-image-01.ad5ab6ce.png";